export const SLICE_NAME = "components";